module.exports = __webpack_public_path__ + "img/icon_gzfcg.fd4b258a.png";